import { ReactNode } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Box, Typography, Button } from "@mui/material";
import { UiSize } from "../ui/styles";
import HelpButton from "./buttons/HelpButton";

type EmptyStateProps = {
  label?: string;
  btnLabel?: string;
  imageSrc?: string;
  onAdd?: () => void;
  children?: ReactNode;
  size?: UiSize;
  startIcon?: ReactNode;
  helpUrl?: string;
  hint?: string;
  hintElement?: ReactNode;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  label,
  btnLabel,
  imageSrc,
  onAdd,
  children,
  size,
  startIcon,
  helpUrl,
  hint,
  hintElement,
}: EmptyStateProps) => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ textAlign: "center", color: "text.primary" }}>
        {imageSrc && (
          <img
            src={imageSrc}
            alt={label}
            style={{ maxWidth: 64, opacity: 0.7 }}
          />
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            my: 3,
            p: 1,
          }}
        >
          <Typography variant="h6">{label}</Typography>
          {helpUrl && <HelpButton helpUrl={helpUrl} color="primary.main" />}
        </Box>
        {onAdd && (
          <Button
            color="primary"
            size={size ?? "small"}
            startIcon={startIcon ?? <AddIcon />}
            onClick={onAdd}
            variant="contained"
          >
            {btnLabel}
          </Button>
        )}
        {children}
        {(hint || hintElement) && (
          <Box sx={{ mt: 1 }}>
            {hint && <Typography variant="caption">{hint}</Typography>}
            {hintElement && (
              <Typography variant="caption" sx={{ display: "block" }}>
                {hintElement}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
